export default __webpack_public_path__ + "media/flags/la-79a72be9.svg";